import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Truck } from "@phosphor-icons/react";
import { useLandingT } from "@/lib/landingI18n";
import { LANDING } from "@/constants/landingTestIds";

export const FinalCta = ({ lang }) => {
  const t = useLandingT(lang);
  return (
    <section className="relative py-20 md:py-28">
      <div className="max-w-[1240px] mx-auto px-5 md:px-8">
        <div className="glass-strong rounded-3xl p-10 md:p-16 relative overflow-hidden text-center">
          <div
            aria-hidden
            className="absolute inset-0 opacity-70 pointer-events-none"
            style={{
              background:
                "radial-gradient(600px 300px at 20% 0%, rgba(16,185,129,0.25), transparent 60%), radial-gradient(600px 300px at 80% 100%, rgba(239,68,68,0.16), transparent 60%)",
            }}
          />
          <div className="relative">
            <div className="kicker mx-auto">
              <span className="dot" />
              {t("finalKicker")}
            </div>
            <h2 className="mt-6 h-section text-white max-w-3xl mx-auto">
              {t("finalTitle")}
            </h2>
            <p className="mt-4 text-slate-300 text-base md:text-lg max-w-xl mx-auto">
              {t("finalSubtitle")}
            </p>

            <div className="mt-8 flex justify-center">
              <Link
                data-testid={LANDING.finalCta}
                to="/app"
                className="btn-neon inline-flex items-center gap-2 px-7 py-4 rounded-xl text-base"
              >
                <Truck size={18} weight="duotone" className="flip-x" />
                {t("finalCta")}
                <ArrowRight size={16} weight="bold" className="flip-x" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export const LandingFooter = ({ lang }) => {
  const t = useLandingT(lang);
  return (
    <footer className="relative border-t border-white/8 py-10">
      <div className="max-w-[1240px] mx-auto px-5 md:px-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-500">
        <div className="flex items-center gap-2">
          <Truck size={14} weight="duotone" className="text-emerald-400 flip-x" />
          <span>LoadWise</span>
        </div>
        <p>{t("footerBuilt")}</p>
        <p>© {new Date().getFullYear()} · {t("footerRights")}</p>
      </div>
    </footer>
  );
};
